import { vcpodeHttp } from '@/http';
import { serialize } from './utils';

const checkRmsStatus = (payload) =>
	vcpodeHttp.post('rms/beneficiario/consulta', { ...payload });

const reprocessRms = (data = {}) => {
	const params = serialize(data);
	return vcpodeHttp.post(`rms/beneficiario/reprocess${params}`);
};

export const rms = {
	checkRmsStatus,
	reprocessRms,
};
